import { brandings } from 'src/config/brandings/index.js'
import native from 'src/config/native.js'
import { i18n } from 'src/config/i18n.ts'
import { DEFAULT_BRANDING, DEFAULT_TRANSLATION_BRANDING } from 'src/config/constants.ts'
import * as Sentry from '@sentry/vue'
import GlobalPrototypes from 'src/config/services/globalPrototypes.ts'

const defaultState = () => ({
  // warning: don´t directly call this, use getBranding
  localBranding: null,
  currentLoadedStyles: null,
  nativeBranding: null
})

export const state = defaultState()

export const getters = {
  getBranding (state) {
    return [state.nativeBranding, state.localBranding, localStorage?.getItem('app_branding'), DEFAULT_BRANDING].find(el => el)
  },
  getBrandingConfig (state, getters) {
    const brandingPriority = getters.getBranding
    return brandings[brandingPriority]()
  }
}
export const mutations = {
  RESET_STATE () {
    // EMPTY
    // WE DO NOT RESET THE BRANDING STATE ON LOGOUT!
  },
  SET_BRANDING (state, { app_branding }) {
    const value = app_branding in brandings ? app_branding : DEFAULT_BRANDING
    localStorage && localStorage.setItem('app_branding', value)
    state.localBranding = value
  },
  SET_NATIVE_BRANDING (state, nativeBranding) {
    state.nativeBranding = nativeBranding
  },
  SET_CURRENT_LOADED_STYLES (state, app_branding) {
    state.currentLoadedStyles = app_branding
  }
}

export const actions = {
  async loadStyles ({ getters, state, commit, dispatch }) {
    if (state.currentLoadedStyles) return
    await dispatch('loadNativeBranding')
    const branding = getters.getBrandingConfig

    if (GlobalPrototypes.compare(state.currentLoadedStyles, branding)) return

    if (state.currentLoadedStyles) {
      return location.reload()
    }

    const config = getters.getBrandingConfig

    await config.styles.load()
    commit('SET_CURRENT_LOADED_STYLES', branding)
  },
  async loadNativeBranding ({ commit }) {
    if (state.nativeBranding) return
    const nativeBranding = await native.getBranding()
    commit('SET_NATIVE_BRANDING', nativeBranding)
  },
  async applyBranding ({ commit, dispatch }, { app_branding }) {
    commit('SET_BRANDING', { app_branding })

    Sentry.getCurrentScope().setTag('branding', app_branding)

    await dispatch('loadStyles')
    await dispatch('loadLanguageVariables')
  },
  async loadLanguageVariables ({ getters }) {
    const me = GlobalPrototypes.store.getters['users/me']
    const school = GlobalPrototypes.store.state.school
    const schoolTypeFallback = 'DEFAULT'
    const resSchoolType = (me?.school?.type?.key || school?.type?.key || schoolTypeFallback).toUpperCase()
    const branding = getters.getBranding

    const prioritizedLanguageVariables = [
      `variables.${DEFAULT_TRANSLATION_BRANDING}.${schoolTypeFallback}`,
      `variables.${DEFAULT_TRANSLATION_BRANDING}.${resSchoolType}`,
      `variables.${branding}.${schoolTypeFallback}`,
      `variables.${branding}.${resSchoolType}`
    ]

    // make sure the array has unique values as 'fallbackLocale' and 'locale' can be the same
    // TODO VUE 3: vee-i18n refactor to `i18n.global.locale` `i18n.global.locale.value` at the end of when legacy API is removed
    const languages = [...new Set([i18n.global.fallbackLocale, i18n.global.locale])]
    const localeIsSameAsFallback = i18n.global.locale.value === i18n.global.fallbackLocale
    const getDeepValue = (obj, path) => path.split('.').reduce((acc, key) => acc?.[key], obj)

    languages.forEach(language => {
      prioritizedLanguageVariables.forEach(el => {
        const localeMessages = i18n.global.getLocaleMessage(language)
        const localeMessageObj = getDeepValue(localeMessages, el)

        if (!localeMessageObj) return

        // TODO VUE 3: vee-i18n add `.value` at the end of when legacy API is removed
        i18n.global.mergeLocaleMessage(i18n.global.locale, { _vars: localeMessageObj })

        // do not merge if 'fallbackLocale' and 'locale' are the same => it's already replaced, no fallback needed
        // do not merge if 'fallbackLocale' and 'language' are not the same => prevent mix-up of lang values with
        // different language in case a VAR exists in 'language' but not in 'fallbackLocale'
        // TODO VUE 3: vee-i18n add `.value` at the end of when legacy API is removed
        if (localeIsSameAsFallback || language !== i18n.global.fallbackLocale) return
        // TODO VUE 3: vee-i18n add `.value` at the end of when legacy API is removed
        i18n.global.mergeLocaleMessage(i18n.global.fallbackLocale, { _vars: localeMessageObj })
      })
    })
  }
}
